export enum PAYWALL_LAYOUT_VERSION {
	DEFAULT = 'DEFAULT',
	DEFAULT_REVERSE = 'DEFAULT_REVERSE',
	ACADEMY = 'ACADEMY',
	MAIL_SINGLE = 'MAIL_SINGLE',
	NEW_ACADEMY = 'NEW_ACADEMY',
	WALKING_DESIGN = 'WALKING_DESIGN',
	WELCOME_TRIAL = 'WELCOME_TRIAL',
	PILATES = 'PILATES',
}
